/**
 * 끌기(누른 채 움직이기)의 이동·놓기를 **누른 자리의 문서**에 건다(2026-10-27 신고).
 *
 * 편집기·결과 영역은 「새 창으로 분리」 하면 분리 창에 그려지는데(포털), 전역 `document` 는 늘 앱 본창의 것이다.
 * 거기에 걸면 분리 창 안에서는 이동이 오지 않아 끌기가 안 되고, 분리 창에서 버튼을 놓아도 본창은 모르니 끌기가
 * 끝나지 않는다 — 그 뒤 본창에서 마우스를 움직이면 분리 창의 편집기가 위아래로 굴렀다(미니맵).
 * 그래서 이벤트를 받은 요소의 ownerDocument 에 걸고, 버튼이 이미 떼어진 이동(buttons === 0)이 오면 그 자리에서 끝낸다.
 *
 * @param {Event} e        mousedown 이벤트(React 합성 이벤트도 된다)
 * @param {(ev: MouseEvent) => void} onMove
 * @param {() => void} [onEnd]
 * @returns {() => void} 직접 끝내기
 */
export function listenDrag(e, onMove, onEnd) {
    const el = (e && (e.currentTarget || e.target)) || null;
    const doc = (el && el.ownerDocument) || document;
    const win = doc.defaultView || window;
    let done = false;
    const stop = () => {
        if (done) return;
        done = true;
        doc.removeEventListener('mousemove', move);
        doc.removeEventListener('mouseup', stop);
        win.removeEventListener('blur', stop);
        if (onEnd) onEnd();
    };
    const move = (ev) => {
        if (ev.buttons === 0) { stop(); return; }
        onMove(ev);
    };
    doc.addEventListener('mousemove', move);
    doc.addEventListener('mouseup', stop);
    win.addEventListener('blur', stop);
    return stop;
}

/** 놓기만 기다린다 — 셀 범위 선택처럼 이동은 요소가 받고 끝만 알면 되는 끌기 */
export function listenRelease(e, onEnd) {
    return listenDrag(e, () => {}, onEnd);
}
